module.exports = __webpack_public_path__ + "static/media/yen.03e1c63e.svg";